module.exports = __webpack_public_path__ + "static/media/ic_employee.b02f3e4a.svg";